/*
 *  Copyright (c) 2018-present, Evgeny Nadymov
 *
 * This source code is licensed under the GPL v.3.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import MainMenuButton from './MainMenuButton';
import SearchInput from './Search/SearchInput';
import { isAuthorizationReady } from '../../Utils/Common';
import AppStore from '../../Stores/ApplicationStore';
import '../ColumnMiddle/Header.css';

import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import TelegramIcon from '@mui/icons-material/Telegram';
import ExploreIcon from '@mui/icons-material/Person';
import MessageIcon from '@mui/icons-material/Message';



class DialogsHeader extends React.Component {
    constructor(props) {
        super(props);

        this.searchInputRef = React.createRef();

        this.state = {
            authorizationState: AppStore.getAuthorizationState(),
            open: false
        };
    }

    setInitQuery(query) {
        const { onSearchTextChange } = this.props;

        const searchInput = this.searchInputRef.current;
        if (searchInput) {
            searchInput.innerText = query;
            if (searchInput.childNodes.length > 0) {
                const range = document.createRange();
                range.setStart(searchInput.childNodes[0], searchInput.childNodes[0].length);
                range.collapse(true);

                const selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
            }
            searchInput.focus();
            onSearchTextChange(query);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { openSearch } = this.props;

        if (openSearch !== prevProps.openSearch) {
            if (openSearch) {
                this.focusInput();
            } else {
                const searchInput = this.searchInputRef.current;
                if (searchInput) {
                    searchInput.innerText = null;
                }
            }
        }
    }

    focusInput() {
        const searchInput = this.searchInputRef.current;
        if (searchInput) {
            searchInput.focus();
        }
    }

    componentDidMount() {
        if (this.props.popup) {
            this.focusInput();
        }

        AppStore.on('updateAuthorizationState', this.onUpdateAuthorizationState);
    }

    componentWillUnmount() {
        AppStore.off('updateAuthorizationState', this.onUpdateAuthorizationState);
    }

    onUpdateAuthorizationState = update => {
        this.setState({ authorizationState: update.authorization_state });
    };

    handleSearch = () => {
        const { onSearch, openSearch } = this.props;
        const { authorizationState } = this.state;
        if (!isAuthorizationReady(authorizationState)) return;

        onSearch(!openSearch);
    };

    handleSearchTextChange = () => {
        const { onSearchTextChange } = this.props;

        const element = this.searchInputRef.current;
        if (!element) return;

        const { innerHTML } = element;
        if (innerHTML === '<br>' || innerHTML === '<div><br></div>') {
            element.innerHTML = null;
        }
        const { innerText } = element;

        onSearchTextChange(innerText);
    };

    handleCloseSearch = () => {
        this.handleSearch();
    };

    handleFocus = () => {
        this.handleSearch();
    };

    storage_selected = () => {
        this.setState({page: "stoarge"});
        // console.log(this.state);
    }

    render() {
        const { openSearch, timeout, popup, currentPage } = this.props;

        let content = null;
        let showBack = false;
        if (openSearch) {
            showBack = true;
            content = (
                <SearchInput
                    inputRef={this.searchInputRef}
                    onChange={this.handleSearchTextChange}
                    onClose={this.handleCloseSearch}
                />
            );
        } else {
            content = <SearchInput inputRef={this.searchInputRef} onFocus={this.handleFocus} />;
        }

        // Only show header-redirects on the chats page
        const showHeaderRedirects = currentPage === 'chats';

        return (
            <>
                <div className='header-master'>
                    <MainMenuButton timeout={timeout} showClose={showBack} popup={popup} onClose={this.handleCloseSearch} />
                    <TelegramIcon 
                        className={`redirectIcon ${currentPage === 'chats' ? 'active' : ''}`} 
                        fontSize="large" 
                        onClick={()=> currentPage !== 'chats' && this.props.page_change("chats")} 
                    />
                    <MessageIcon 
                        className={`redirectIcon ${currentPage === 'chat_explore' ? 'active' : ''}`} 
                        fontSize="large" 
                        onClick={()=> currentPage !== 'chat_explore' && this.props.page_change("chat_explore")} 
                    />
                    <ExploreIcon 
                        className={`redirectIcon ${currentPage === 'explore' ? 'active' : ''}`} 
                        fontSize="large" 
                        onClick={()=> currentPage !== 'explore' && this.props.page_change("explore")} 
                    />
                    <AccountBalanceWalletIcon 
                        className={`redirectIcon ${currentPage === 'wallet' ? 'active' : ''}`} 
                        fontSize="large" 
                        onClick={()=> currentPage !== 'wallet' && this.props.page_change("wallet")} 
                    />
                </div>
                {showHeaderRedirects && (
                    <div className='header-redirects'>
                        {content}
                    </div>
                )}
            </>
        );
    }
}

DialogsHeader.propTypes = {
    openSearch: PropTypes.bool.isRequired,
    onClick: PropTypes.func,
    onSearch: PropTypes.func.isRequired,
    onSearchTextChange: PropTypes.func.isRequired,
    timeout: PropTypes.bool,
    popup: PropTypes.bool,
    currentPage: PropTypes.string,
    page_change: PropTypes.func.isRequired
};

// Default props
DialogsHeader.defaultProps = {
    currentPage: 'chats' // Default to chats page for backward compatibility
};

export default DialogsHeader;
